import {Helper} from "@nolimitcity/promo-panel/bin/utils/Helper";
import {WINTYPE} from "@nolimitcity/promo-panel/bin/enums/ASEnums";
import {RoadKillGameData} from "./server/RoadKillData";
import {RoadKillGameMode} from "./server/RoadKillGameMode";
import {RoadKill} from "./RoadKill";
import {
    ActionSpinOptions,
    ActionSpinSound,
    ASWinData,
    PromoPanelGameConfiguration
} from "@nolimitcity/promo-panel/bin/interfaces/ASInterfaces";
import {RoadKillSound} from "./sound/RoadKillSound";
import {BelowStakeWinRestriction} from "./server/BelowStakeWinRestriction";

export class RoadKillPromoPanelConfig implements PromoPanelGameConfiguration {
    constructor() {
    }

    public getActionSpinOptions(): ActionSpinOptions {
        return {
            hasActionSpin: true,
            gameName: "RoadKill",
            graphics: {
                backgroundTextureName: "introBg" //Loaded in intro view config.
            },
            getParsedData: (response: RoadKillGameData, bet: number, prevResponse: RoadKillGameData): ASWinData => {
                const parsedData: ASWinData = {
                    totalWin: response.accumulatedRoundWin,
                    wasFeatureBuy: response.wasFeatureBuy,
                    freeSpinTriggeredThisSpin: this.ifFreeSpinTriggeredThisSpin(response),
                    totalSpinWinnings: response.totalSpinWinnings,
                    isBigWin: this.isBigWin(response),
                    winType: WINTYPE.NORMAL,
                    featureName: this.getFeatureName(response),
                    isRoundComplete: this.isRoundComplete(response),
                    isBonusEnd: this.isBonusEnd(response),
                    isWinCapHit: false,

                }
                return parsedData;
            }
        };
    }

    public onActionSpinPlaySound(trigger: ActionSpinSound): void {
        if (trigger == ActionSpinSound.WIN) {
            RoadKill.soundPlayer.playTrack(RoadKillSound.AS_WIN);
        } else if (trigger == ActionSpinSound.BIG_WIN) {
            RoadKill.soundPlayer.playTrack(RoadKillSound.AS_WIN_BIG);
        }
    }

    private ifFreeSpinTriggeredThisSpin(response: RoadKillGameData): boolean {
        return response.mode === RoadKillGameMode.NORMAL && response.nextMode !== RoadKillGameMode.NORMAL;
    }

    private isBigWin(response: RoadKillGameData): boolean {
        let win: number = response.mode === RoadKillGameMode.NORMAL ? response.accumulatedRoundWin : response.totalSpinWinnings;

        if (response.wasFeatureBuy) {
            const betPrice = BelowStakeWinRestriction.getBuyFeaturePrice();
            let winRatio: number = Helper.ceilToDecimals((win / betPrice), 2);
            return winRatio >= 1;
        }

        let winRatio: number = Helper.ceilToDecimals((win / response.playedBetValue), 2);
        return winRatio >= 15;
    }

    private getFeatureName(response: RoadKillGameData): string {
        if (response.mode === RoadKillGameMode.NORMAL && (response.nextMode === RoadKillGameMode.FREESPIN || response.nextMode === RoadKillGameMode.FREESPIN_SUPER || RoadKillGameMode.RESPIN)) {
            if (response.nextMode === RoadKillGameMode.FREESPIN_SUPER) {
                return "JUNKYARD ASSAULT";
            } else if (response.nextMode === RoadKillGameMode.FREESPIN) {
                return "TEAM ASSEMBLE";
            } else {
                return "CALL TO ARMS";
            }
        } else if ((response.mode === RoadKillGameMode.FREESPIN_SUPER || response.mode === RoadKillGameMode.FREESPIN || response.mode === RoadKillGameMode.RESPIN) && response.nextMode === RoadKillGameMode.NORMAL) {
            if (response.mode === RoadKillGameMode.FREESPIN_SUPER) {
                return "JUNKYARD ASSAULT";
            } else if (response.mode === RoadKillGameMode.FREESPIN) {
                return "TEAM ASSEMBLE";
            } else {
                return "CALL TO ARMS";
            }
        } else {
            if (response.mode === RoadKillGameMode.FREESPIN_SUPER) {
                return "JUNKYARD ASSAULT";
            } else if (response.mode === RoadKillGameMode.FREESPIN) {
                return "TEAM ASSEMBLE";
            } else if (response.mode === RoadKillGameMode.RESPIN) {
                return "CALL TO ARMS";
            } else {
                return "";
            }
        }
    }

    private isRoundComplete(response: RoadKillGameData): boolean {
        return true;
    }

    private isBonusEnd(response: RoadKillGameData): boolean {
        return response.nextMode === RoadKillGameMode.NORMAL && (response.mode === RoadKillGameMode.FREESPIN || response.mode === RoadKillGameMode.SUPER_FREESPIN);
    }


}